import { makeStyles } from '@material-ui/core'
 import React, { useEffect } from 'react'
import { Navbar, Footer } from '..'
import { GridBlue } from '../../atoms'
import { Ubanner, Overview, Quality, QualityReverse, Visit, Visit1 } from '../../molecules' 
import { tokens } from './tokens'
import { Header } from './Header'
import { Hero } from './Hero'
import { Intro } from './Intro'
import { Problems } from './Problems'
import { Benefits } from './Benefits'
import { Stats } from './Stats'
import { WhyChoose } from './WhyChoose'
import { Categories } from './Categories'
import { Industries } from './Industries'
import { Process } from './Process'
import { CtaBar } from './CtaBar'
import { Faqs } from './Faqs'
import { GetInTouch } from './GetInTouch'
import heroImg from '../../assets/mechanicaldesign/newbanner.png'

// NOTE: The original static markup's <footer> was commented out, which
// suggests your live site renders a shared/global Footer component
// elsewhere (e.g. in App.js / a layout wrapper), same as IPcoreTemplate
// does with <Footer />. Drop that shared component in below once you
// wire this page in — it's intentionally left out here.

const FONT_AWESOME_ID = 'pcbtest-font-awesome-cdn'
const FONT_AWESOME_URL = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css'
 
// Loads Font Awesome only while this page is mounted, and removes it again
// on unmount so it doesn't leak into other pages.
function useScopedFontAwesome() {
    useEffect(() => {
        if (document.getElementById(FONT_AWESOME_ID)) return undefined
 
        const link = document.createElement('link')
        link.id = FONT_AWESOME_ID
        link.rel = 'stylesheet'
        link.href = FONT_AWESOME_URL
        document.head.appendChild(link)
 
        return () => {
            const existing = document.getElementById(FONT_AWESOME_ID)
            if (existing) existing.remove()
        }
    }, [])
}

const useStyles = makeStyles(() => ({
    root: { fontFamily: tokens.fontBody },
}))

export function MechanicalTemplate() {
     useScopedFontAwesome()
    const classes = useStyles()
     
    return (
        <div className={classes.root}>
            <Ubanner
                            Background={heroImg}
                            maintext="Mechanical Design Services"
                            subtext="Leading PCBA Test Fixtures Manufacturer Delivering Innovative PCB Test Solutions"
                        />
                        <GridBlue>
                            <Navbar />
            
                            <Overview
                                path="Services / Mechanical Design Services"
                                sub1="SLS is your trusted partner for PCBA test automation services, delivering
                    customized testing solutions tailored to your manufacturing requirements. We
                    specialize in designing and developing custom test fixtures, mechanical and
                    pneumatic fixtures, functional test systems (FCT), in-circuit test systems
                    (ICT), and embedded test solutions. Our advanced automation test fixtures and
                    industry-leading software ensure accurate, error-free testing while improving
                    efficiency, reliability, and production quality.SLS has been spearheading the design and delivery of world-class Mechanical Design Services for more than two decades. We hold an extensive portfolio of Mechanical Design projects with exceptional time-to-market and ever-growing functionalities, serving 150+ clients globally. Our ready-to-deploy Mechanical Design solutions are designed to meet the dynamic needs of the market and match pace with the changing technology status quo, always aiming to deliver excellence."
                            />
                        </GridBlue>
        
            {/* <Header /> */}
            <Problems />
            <Benefits />
            <Stats />
            <WhyChoose />
            <Categories />
            <Industries />
            <Process />
            <CtaBar />
            <Faqs />
            <GetInTouch />
             <Footer />
        </div>
    )
}
